module.exports = __webpack_public_path__ + "img/7.5dd9c78d.svg";